import { config } from "@/constants";

export default {
  install(Vue) {
    Vue.prototype.$websitePath = websitePath;

    Vue.mixin({
      filters: {
        websitePath: websitePath,
      },
    });
  },
};

function websitePath(path) {
  if (!path.startsWith("/")) {
    path = "/" + path;
  }

  let baseUrl = config.websiteBaseURL.replace(/\/+$/, "");

  return `${baseUrl}${path}`;
}
